import { useRef, useEffect } from 'react';

const usePreventWindowScroll = () => {
  const oldBodyOverflowY = useRef();
  const oldBodyPosition = useRef();
  const oldBodyTop = useRef();
  const oldBodyWidth = useRef();
  const oldWindowScrollPos = useRef(0);
  useEffect(() => {
    oldBodyOverflowY.current = document.body.style['overflow-y'];
    oldBodyTop.current = document.body.style.top;
    oldBodyWidth.current = document.body.style.width;
    oldBodyPosition.current = document.body.style.position;
    oldWindowScrollPos.current = window.pageYOffset;
    document.body.style['overflow-y'] = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${oldWindowScrollPos.current}px`; // Cleanup

    return () => {
      if (oldBodyOverflowY.current) {
        document.body.style['overflow-y'] = oldBodyOverflowY.current;
      } else {
        document.body.style.removeProperty('overflow-y');
      }

      if (oldBodyPosition.current) {
        document.body.style['position'] = oldBodyPosition.current;
      } else {
        document.body.style.removeProperty('position');
      }

      if (oldBodyTop.current) {
        document.body.style['top'] = oldBodyTop.current;
      } else {
        document.body.style.removeProperty('top');
      }

      if (oldBodyWidth.current) {
        document.body.style['width'] = oldBodyWidth.current;
      } else {
        document.body.style.removeProperty('width');
      }

      window.scrollTo(0, oldWindowScrollPos.current);
    };
  }, []);
};

export { usePreventWindowScroll as u };
